import instance from "@/services/api";

export const remarketInfoAPI = {
  async getContractorInfo(contractor_id) {
    return await instance()
      .get(`/handbook/contractor/contractor_info/${contractor_id}/`,)
      .then((res) => res?.data);
  },
  async updateContractorInfo(body) {
    return await instance()
      .post(`/handbook/contractor/logo/`, body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res?.data);
  },
  async getContractorPhotos(contractor_id) {
    return await instance()
      .get(`/handbook/contractor/photo_read/${contractor_id}/`,)
      .then((res) => res?.data);
  },
  async addContractorPhoto(body) {
    return await instance()
      .post(`/handbook/contractor/photo_add/`, body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res?.data);
  },
  async deleteContractorPhoto(partner_project_photo_id) {
    return await instance()
      .delete(`/handbook/contractor/${partner_project_photo_id}/photo_delete/`)
      .then((res) => res?.data);
  },
  async getContractorReviews(contractor_id) {
    return await instance()
      .get(`/handbook/contractor/review_read/${contractor_id}/`,)
      .then((res) => res?.data);
  },
  async addContractorReview(body) {
    return await instance()
      .post(`/handbook/contractor/review_upd/`, body)
      .then((res) => res?.data);
  },
  async deleteContractorReview(partner_review_id) {
    return await instance()
      .delete(`/handbook/contractor/${partner_review_id}/review_del/`)
      .then((res) => res?.data);
  },
}